import {Box, Hide, HStack, Show, Text, useDevice} from 'platform/foundation';

import {suffixTestId, TestIdProps} from 'shared/web';

import i18n from '../../../i18n/i18n';
import {AvailableCar} from '../../../types/AvailableCar';
import {PriceReportType} from '../../../types/PriceReportType';
import {getDifference} from '../../../utils/getDifference';
import {mileageFormatter} from '../../../utils/mileageFormatter';
import {HorizontalValue, HorizontalValueProps} from './HorizontalValue';
import {VerticalValue, VerticalValueProps} from './VerticalValue';

interface VehicleCardContentMileageProps extends TestIdProps {
  vehicle: AvailableCar;
  priceReport: PriceReportType;
  isMyVehicle: boolean;
}

export function VehicleCardContentMileage(props: VehicleCardContentMileageProps) {
  const isMobile = useDevice() === 'mobile';

  const mileageDifference = getDifference(
    props.vehicle.mileage,
    props.priceReport?.vehicle.mileage
  );

  const valueProps: HorizontalValueProps | VerticalValueProps = {
    value: props.vehicle.mileage,
    difference: props.isMyVehicle ? undefined : mileageDifference,
    formatter: mileageFormatter,
    differenceReverseColor: true,
    isRow: !isMobile,
    isMyVehicle: props.isMyVehicle,
    'data-testid': suffixTestId('mileage', props),
  };

  return (
    <>
      <Hide onMobile>
        <Box flex={1}>
          <VerticalValue {...valueProps} />
        </Box>
      </Hide>

      <Show onMobile>
        <HStack justify="space-between" align="center">
          <Text size="xSmall" color="secondary">
            {i18n.t('entity.table.mileage')}
          </Text>
          <HorizontalValue {...valueProps} />
        </HStack>
      </Show>
    </>
  );
}
